<!-- ***************************************************************************************************************************** -->
<!-- Form Div for Courses Explorer/CourseCombinations -->
<tool-form formTitle="Combo Filter">
  <form
    [formGroup]="courseComboForm"
    (ngSubmit)="courseComboSubmit()"
    class="form-content"
  >
    <!-- Student Type Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select a Student Type</mat-label>
      <mat-select name="student_type" formControlName="student_type" required>
        <mat-option value="all">All</mat-option>
        <mat-option value="ftic">FTIC (First Time In College)</mat-option>
        <mat-option value="transfer">Transfer</mat-option>
      </mat-select>
      <mat-error
        *ngIf="this.courseComboForm.controls['student_type'].invalid"
        >{{ getErrorMessage() }}</mat-error
      >
    </mat-form-field>

    <!-- Semester Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select a Semester</mat-label>
      <mat-select formControlName="semester" required>
        <mat-option value="all">All</mat-option>
        <mat-option value="fall">Fall</mat-option>
        <mat-option value="spring">Spring</mat-option>
        <mat-option value="summer">Summer</mat-option>
      </mat-select>
      <mat-error *ngIf="this.courseComboForm.controls['semester'].invalid">{{
        getErrorMessage()
      }}</mat-error>
    </mat-form-field>

    <!-- Number of Courses Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select Number of Courses</mat-label>
      <mat-select name="combo_size" formControlName="combo_size" required>
        <mat-option value="1">1</mat-option>
        <mat-option value="2">2</mat-option>
        <mat-option value="3">3</mat-option>
        <mat-option value="4">4</mat-option>
        <mat-option value="5">5</mat-option>
      </mat-select>
      <mat-error *ngIf="this.courseComboForm.controls['combo_size'].invalid">{{
        getErrorMessage()
      }}</mat-error>
    </mat-form-field>

    <!-- Course Level Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select Course Level(s)</mat-label>
      <mat-select
        formControlName="course_levels"
        required
        multiple
        (selectionChange)="handleCourseLevelsChange($event)"
      >
        <mat-option value="Any">Any</mat-option>
        <mat-option value="1">1000</mat-option>
        <mat-option value="2">2000</mat-option>
        <mat-option value="3">3000</mat-option>
        <mat-option value="4">4000</mat-option>
      </mat-select>
      <mat-error *ngIf="this.courseComboForm.controls['course_levels'].invalid"
        >You must select at least one value</mat-error
      >
    </mat-form-field>

    <!-- Submit Button -->
    <tool-form-action-button
      text="Submit"
      [disabled]="!courseComboForm.valid"
      (onClick)="closeDialog()"
    ></tool-form-action-button>
  </form>
</tool-form>
